import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { getApplicantFormFirstErrorField } from './useApplicantFormErrorFocus.utils'

export function useApplicantFormErrorFocus(fieldRefs) {
  const { errors, submitCount } = useFormikContext()

  const focusedSubmitCountRef = useRef(0)

  useEffect(() => {
    const name = getApplicantFormFirstErrorField(errors)

    if (name && submitCount > focusedSubmitCountRef.current) {
      focusedSubmitCountRef.current = submitCount

      fieldRefs[name]?.current?.focus()
    }
  }, [errors, submitCount])
}
